
























import Vue from 'vue'
import LanguageSelector from '@/components/languageSelector.vue'
import {getCookie, setDomainCookie, deleteCookie} from '@js/libs/cookie-handler'
import { VueI18nExtended } from './assets/js/interfaces'

export default Vue.extend({
  data() {
    return {
      referer: document.referrer
    }
  },
  components: {
    languageSelector: LanguageSelector
  },
  created() {
    deleteCookie('auth')
  },
  computed: {
    getStyles(): {} {
      const i18n = this.$i18n as VueI18nExtended

      return {
        backgroundImage: `url(\"${i18n.whitelabel.bg}\")`,
        backgroundColor: i18n.whitelabel.bgColor
      }
    }
  },
  methods: {
    setToken(token: string): void {
      setDomainCookie(token)

      if(getCookie('auth') === token) {
          this.referer
          ? window.location.replace(this.referer)
          : window.location.replace(`//${location.hostname}`)// this.$router.push('/portal')
      } else {
        throw new Error('cookie not set')
      }
    }
  }
})
